import { Link, Spacer, Typography } from "@fullscript/aviary-web";
import type { ReactNode } from "react";
import { Trans, useTranslation } from "react-i18next";

import { sharedRoutes } from "@shared/data/sharedRoutes";
import { l } from "@shared/locales/i18n";

import * as styles from "./EnterPhoneNumber.styles";

interface Props {
  children: ReactNode;
  isModal?: boolean;
}

const EnterPhoneNumber = ({ children, isModal }: Props) => {
  const { t } = useTranslation();

  const renderContent = () => {
    if (isModal) {
      return (
        <>
          <Typography
            customCss={styles.title}
            variant="h4"
            intention="neutral"
            colorIntensity="bold"
          >
            {t(l.mfa.enterMobilePhone.title)}
          </Typography>
          <Typography isMarginless>{t(l.mfa.enterMobilePhone.subtitle)}</Typography>
          <Typography>
            <Link href={sharedRoutes.external.enablingMultiFactorAuthenticationSMSOption}>
              {t(l.sharedCommon.learnMore)}.
            </Link>
          </Typography>
          <Spacer />
        </>
      );
    }

    return (
      <div css={styles.header}>
        <Typography customCss={styles.title} variant="h1" intention="neutral" colorIntensity="bold">
          {t(l.mfa.enterMobilePhone.title)}
        </Typography>
      </div>
    );
  };

  return (
    <>
      {renderContent()}
      <Typography fontWeight="bold" isMarginless>
        {t(l.mfa.step1)}
      </Typography>
      <Typography>{t(l.mfa.enterMobilePhone.enterYourNumber)}</Typography>
      <Spacer size="small" />
      {children}
      <Spacer size="large" />
      <Typography
        variant="caption"
        data-testid="mobile-phone-disclaimer"
        intention="neutral"
        colorIntensity="subtle"
      >
        <Trans i18nKey={l.mfa.enterMobilePhone.disclaimer}>
          Using your mobile number for security means you accept our
          <Link href={sharedRoutes.external.privacyPolicy}>privacy policy</Link> and
          <Link href={sharedRoutes.external.termsOfService}>Terms of Service</Link>. Standard text
          message rates may apply.
        </Trans>
      </Typography>
    </>
  );
};

export { EnterPhoneNumber };
